import './leadGen.css';

dispatcher.listenTo(dispatcher, 'leadGenView:init', function () {
  new LeadGenView();
});

export const LeadGenView = Backbone.View.extend({
  selector: $('.js-leadGen'),
  initialize() {
    if (this.selector.length && !$('.is-partner').length > 0) {
      this.initLeadGen(this.selector);
    }
  },
  initLeadGen($element) {
    let dataLeadGen,
      minCount = 2;

    if (cookieManagement.getCookie('leadGen') !== null) {
      let storedData = JSON.parse(cookieManagement.getCookie('leadGen'));
      dataLeadGen = storedData;
      let currentCount = parseInt(dataLeadGen.count);

      if (currentCount < minCount && dataLeadGen.location.split('?')[0] !== window.location.href.split('?')[0]) {
        dataLeadGen = {
          location: window.location.href.split('?')[0],
          count: currentCount + 1
        };
        cookieManagement.createCookie('leadGen', JSON.stringify(dataLeadGen), 30);
      }
    } else {
      dataLeadGen = {
        location: window.location.href.split('?')[0],
        count: 1
      };
      cookieManagement.createCookie('leadGen', JSON.stringify(dataLeadGen), 30);
    }

    if (cookieManagement.getCookie('newsletter_status') !== 'closed' && dataLeadGen.count >= minCount) {
      $element.show('fast').addClass('anim');

      if (dataLeadGen.count === minCount) {
        Tracking.dataLayerPush({
          event: 'popinDisplay',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'popin_display',
          popinName: 'Lead gen sticky button'
        });

        dataLeadGen = {
          location: window.location.href.split('?')[0],
          count: minCount + 1
        };

        cookieManagement.createCookie('leadGen', JSON.stringify(dataLeadGen), 30);
      }
    }

    this.initEvents($element);
  },
  initEvents($element) {
    const isIosRecent = DEVICE.navigator.isIos() && DEVICE.navigator.getVersion().version >= 16;
    const panelCtaHeight = isIosRecent ? $('.panelCtaText').innerWidth() + 50 : document.querySelector('.panelCtaText').offsetWidth + 5;
    const panelMaxHeight = $('.panelCtaText').text().length * 16;

    isIosRecent ? $('.leadGen .panelCta').css({
      'height': `${panelCtaHeight}px`,
      'max-height': `${panelMaxHeight}px`
    }) : $('.leadGen .panelCta').height(panelCtaHeight);

    $element.on('click', '.js-panelCta, .js-minimizeBtn', e => {
      e.preventDefault();

      $element.toggleClass('open');

      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Lead gen sticky button',
        gaLabel: $(e.currentTarget).hasClass('minimizeBtn') ? 'minimise' : $element.hasClass('open') ? 'open' : 'closetheflap'
      });
    })
      .on('click', '.newsletter-link', () => {
        Tracking.dataLayerPush({
          event: 'clickEvent',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Lead gen sticky button',
          gaLabel: 'see the condition'
        });
      })
      .on('click', '.js-closeBtn, .js-newsletterClose', e => {
        $element.removeClass('open');
        $element.fadeOut('slow');

        cookieManagement.createCookie('newsletter_status', 'closed', 30);

        Tracking.dataLayerPush({
          event: 'clickEvent',
          gaCategory: PAGE_SCRIPTS.page_template,
          gaAction: 'Lead gen sticky button',
          gaLabel: $(e.currentTarget).hasClass('js-newsletterClose') ? 'close confirmation' : 'close'
        });
      });

    $('.leadGen-layer').on('click', () => {
      $element.removeClass('open');
      Tracking.dataLayerPush({
        event: 'clickEvent',
        gaCategory: PAGE_SCRIPTS.page_template,
        gaAction: 'Lead gen sticky button',
        gaLabel: 'closetheflap'
      });
    });
  }
});